// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y91G","fullView":"styles_fullView__34JYq"};